/* tslint:disable */
import { Injectable } from '@angular/core';
import { User } from '../../models/User';
import { Mechanics } from '../../models/Mechanics';
import { Cfdi } from '../../models/Cfdi';
import { TicketCfdi } from '../../models/TicketCfdi';
import { FacturasGlobales } from '../../models/FacturasGlobales';
import { Email } from '../../models/Email';

export interface Models { [name: string]: any }

@Injectable()
export class SDKModels {

  private models: Models = {
    User: User,
    Mechanics: Mechanics,
    Cfdi: Cfdi,
    TicketCfdi: TicketCfdi,
    FacturasGlobales: FacturasGlobales,
    Email: Email,
    
  };

  public get(modelName: string): any {
    return this.models[modelName];
  }

  public getAll(): Models {
    return this.models;
  }

  public getModelNames(): string[] {
    return Object.keys(this.models);
  }
}
